// Types
import type {
  Operation,
} from 'fc-flow-types/models'

import type {
  Job,
} from 'fc-model-sampling-jobs/types'

import type {
  Action,
} from 'fc-flow-types/redux'

// Effect Managers
import { put } from 'redux-saga/effects'

// operator
import operator from '../operator'

// Utils
import { validateModel } from 'fc-model-sampling-jobs'

// Exports
export default function *validateOperationSaga (operation: Operation<Job>): Generator<*, *, *> {
  const errors = yield validateModel(operation.model.job)

  if (errors.length) {
    const nextOperation = {
      ...operation,
      submitting: false,
      errors,
    }
    const action: Action<Object> = yield operator.actionCreators.updateOperation(nextOperation)

    yield put(action)

    return nextOperation
  }

  return operation
}
